"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { ROUTES_WITHOUT_NAVBAR_SPACER } from "~/constants/navigation";

const NavbarSpacer = () => {
    const pathname = usePathname();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) return null;

    const hideSpacer =
        ROUTES_WITHOUT_NAVBAR_SPACER.includes(pathname) ||
        pathname.startsWith("/p/");

    // The 404 page sits under the header and can render on any path, so it hides the spacer itself
    return hideSpacer ? null : (
        <div className="h-[88px] [body:has([data-not-found])_&]:hidden" aria-hidden />
    );
};

export default NavbarSpacer;
